// extracted by mini-css-extract-plugin
export default {"mainWrapper":"customer-document-tab_mainWrapper__-0tx-","headerWrapper":"customer-document-tab_headerWrapper__ZM8Hn"};